import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBagLike1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShoppingBagLike1"><Path d="M12 20.5H3.5L4.5 3.5H19.5L20.0145 12.2464" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 17.6089C21.5 20.1212 18 21.5 18 21.5C18 21.5 14.5 20.1212 14.5 17.6089C14.5 15.7261 16.3813 14.6052 18 15.6513C19.6187 14.6052 21.5 15.7261 21.5 17.6089Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconShoppingBagLike1;
